import { render, staticRenderFns } from "./ModalEditSpaceConfigurations.vue?vue&type=template&id=644987ef"
import script from "./ModalEditSpaceConfigurations.vue?vue&type=script&lang=js"
export * from "./ModalEditSpaceConfigurations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports